import { ShieldCheck, AlertTriangle, Scale, HeartHandshake, FileWarning } from "lucide-react";
import { Layout, PageHeader } from "../components/Layout";

const SECTIONS = [
  { icon: ShieldCheck, title: "Seller Standards", body: "All sellers must provide accurate health, registration and vaccination information. Misleading claims result in listing removal and account review." },
  { icon: HeartHandshake, title: "Breeder Standards", body: "Breeders are admin-approved and tiered by verification depth. We prioritize animal welfare, ethical breeding practices and responsible placement." },
  { icon: Scale, title: "Marketplace Rules", body: "Duplicate listings, misrepresentation and off-platform circumvention are prohibited. Buyers should verify all details directly with the seller before purchase." },
  { icon: HeartHandshake, title: "Animal Welfare & Placement", body: "E.O.N promotes responsible ownership. Guardian and working breeds are placed with fit, prepared homes. Education is encouraged before acquisition." },
  { icon: FileWarning, title: "Fraud Reporting & Disputes", body: "Suspect a fraudulent listing or need to raise a dispute over a deposit, product or membership? Contact our team and we will review with an evidence trail." },
];

export default function TrustSafety() {
  return (
    <Layout>
      <PageHeader label="Trust & Safety" title="Built On Trust"
        subtitle="Animal welfare, fraud prevention and moderation come before feature count. Here's how we protect buyers and dogs." />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SECTIONS.map((s) => (
            <div key={s.title} className="eon-card p-8">
              <s.icon size={26} className="text-eon-gold" />
              <h3 className="font-display text-xl font-bold mt-5">{s.title}</h3>
              <p className="text-sm text-eon-text/75 mt-3 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <div className="eon-card p-8 border-eon-gold/40 flex flex-col justify-center bg-eon-surface">
            <AlertTriangle size={26} className="text-eon-gold" />
            <h3 className="font-display text-xl font-bold mt-5">Report a Concern</h3>
            <p className="text-sm text-eon-text/75 mt-3 leading-relaxed">Email <span className="text-eon-gold">trust@eoninfinity.com</span> with listing links and details. Our moderation team responds within 48 hours.</p>
          </div>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-6 gap-3">
          {["Terms","Privacy","Seller Standards","Breeder Standards","Refund Policy","Accessibility"].map((p) => (
            <div key={p} className="border border-eon-border p-4 text-center text-xs text-eon-muted hover:text-eon-gold hover:border-eon-gold transition-colors cursor-pointer">{p}</div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
